var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-center" },
    [
      _vm.text
        ? _c("span", { on: { click: _vm.handleLock } }, [
            _vm._v(_vm._s(_vm.text)),
          ])
        : _c(
            "div",
            {
              staticClass: "flex-center flex-col pointer",
              on: { click: _vm.handleLock },
            },
            [
              _c("img", {
                staticStyle: { width: "22px", height: "22px" },
                attrs: { src: require("@/static/icon_top_lock.png"), alt: "" },
              }),
              _c("span", { staticClass: "color-666 font-12" }, [
                _vm._v("锁屏"),
              ]),
            ]
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置锁屏密码",
            visible: _vm.box,
            width: "30%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.box = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "锁屏密码",
                    prop: "passwd",
                    rules: [{ required: true, message: "锁屏密码不能为空" }],
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入锁屏密码" },
                      model: {
                        value: _vm.form.passwd,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "passwd", $$v)
                        },
                        expression: "form.passwd",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-lock" },
                        on: { click: _vm.handleSetLock },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }